var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIotIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 23.6668H8C5.79333 23.6668 4 21.8735 4 19.6668C4 17.9468 5.09333 16.4535 6.67333 15.9002C6.67333 15.8202 6.67333 15.7468 6.67333 15.6668C6.67333 13.0935 8.76667 11.0002 11.34 11.0002C12.14 11.0002 12.92 11.2068 13.6133 11.5935C14.8067 9.5935 16.9733 8.3335 19.34 8.3335C23.0133 8.3335 26.0067 11.3268 26.0067 15.0002C26.0067 15.3802 25.9733 15.7668 25.9 16.1602C27.18 16.8468 28.0067 18.1935 28.0067 19.6668C28.0067 21.8735 26.2133 23.6668 24.0067 23.6668H24ZM11.3333 12.3335C9.49333 12.3335 8 13.8268 8 15.6668C8 15.8602 8.02 16.0602 8.06 16.2735L8.18 16.9335L7.52 17.0535C6.25333 17.2868 5.33333 18.3868 5.33333 19.6735C5.33333 21.1468 6.52667 22.3402 8 22.3402H24C25.4733 22.3402 26.6667 21.1468 26.6667 19.6735C26.6667 18.5602 25.96 17.5602 24.9 17.1735L24.3267 16.9668L24.4867 16.3735C24.6067 15.9135 24.6733 15.4468 24.6733 15.0002C24.6733 12.0602 22.28 9.66683 19.34 9.66683C17.24 9.66683 15.3267 10.9068 14.4667 12.8335L14.1133 13.6268L13.44 13.0802C12.84 12.5935 12.1133 12.3335 11.34 12.3335H11.3333Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIotIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Iot_Icon.2855eec318afbf19052c85f27c7a4fe5.svg";